export const CheckOne = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM7.99081 11.1609C7.52751 10.7579 6.82485 10.7681 6.37328 11.2015C5.89516 11.6605 5.8796 12.4201 6.33854 12.8982L9.30386 15.9876L9.34377 16.0278L9.43477 16.1111C10.1486 16.7207 11.223 16.6808 11.8892 15.9998L17.8202 9.93654L17.893 9.85503C18.2812 9.37927 18.2489 8.67727 17.8015 8.23958L17.7199 8.16671C17.2442 7.77852 16.5422 7.81085 16.1045 8.2583L10.6065 13.8788L8.06998 11.2363L7.99081 11.1609Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

// Generated from SVG to Code Figma Plugin

export const CheckSquared = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4ZM4.83175 7.68135C4.52579 7.3626 4.01936 7.35223 3.70061 7.65818C3.38186 7.96414 3.37149 8.47057 3.67745 8.78932L6.00234 11.2114C6.47153 11.7002 7.25211 11.7039 7.7259 11.2196L12.3324 6.51034C12.6414 6.19449 12.6358 5.68799 12.3199 5.37903C12.0041 5.07008 11.4976 5.07566 11.1886 5.39151L6.87078 9.80565L4.83175 7.68135Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
